import * as types from "./actionsTypes";

export function setConfig(data) {
  return {
    type: types.SET_CONFIG,
    data: data,
  };
}

export function setShopConfig(data) {
  return {
    type: types.SET_SHOP_CONFIG,
    data: data,
  };
}

export function resetConfig() {
  return {
    type: types.RESET_CONFIG,
  };
}
